<span [innerHTML]="safeIcon()"></span>
